const extraAnalyticsData = () => ({
  parcours_type: null,
  user_id: null,
  reprise_parcours: null,
  organisme: null
});

export default extraAnalyticsData;
